<template>
  <div>
    <v-snackbar v-model="snackbar" :timeout="snackbar_timeout" :color="snackbar_color" :top="true">
      {{ snackbar_message }}
    </v-snackbar>

    <v-card flat class="mt-5">
      <v-card-title>
        <h6 class="primary--text">Liste des types thématique</h6>
        <v-spacer></v-spacer>

        <v-btn rounded color="primary" class="text-capitalize" v-if="$can('create thematic types')">
          <export-excel :data="thematic_types" name="thematique.xls" :export-fields="thematicTypes_fields">
            Exporter
            <v-icon right>mdi-share-outline</v-icon>
          </export-excel>
        </v-btn>
        <v-spacer></v-spacer>

        <v-dialog v-model="dialog_edit" max-width="500px">
          <template v-slot:activator="{ on }">
            <v-btn rounded color="primary" dark class="mb-2" v-on="on" v-if="$can('create thematic types')">
              Ajouter <v-icon right>mdi-plus-circle-outline</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm12 md12>
                    <v-text-field v-model="editedItem.name" label="Nom du type thematic" solo></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-autocomplete v-model="editedItem.event_type_id" :items="event_types" item-text="name"
                      item-value="id" label="Type d'évenement" clearable solo></v-autocomplete>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="info" rounded @click="dialog_edit = false">Fermer</v-btn>
              <v-btn color="primary" :loading="load" :disabled="load" rounded @click="save">Enregistrer</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-spacer></v-spacer>

        <v-text-field v-model="search" append-icon="mdi-magnify" label="Rechercher un type thématique" single-line solo
          hide-details>
        </v-text-field>
      </v-card-title>
    </v-card>

    <v-data-table v-if="thematic_types" :headers="headers" :items="thematic_types" :loading="loading"
      loading-text="Loading..." sort-by="name" :search="search" class="elevation-1">

      <template v-slot:item.action="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)" v-if="$can('edit thematic types')">
          mdi-pencil-outline
        </v-icon>
        <v-icon small @click="deleteItem(item)" v-if="$can('delete thematic types')">
          mdi-trash-can-outline
        </v-icon>
      </template>

    </v-data-table>

    <v-layout row justify-center>
      <v-dialog v-model="dialog_deletion" max-width="290">
        <v-card>
          <v-card-title class="headline">Suppression</v-card-title>
          <v-card-text class="text-center">
            Etes-vous sûr de vouloir supprimer ce type thématique ?
          </v-card-text>
          <v-card-actions>
            <v-btn color="orange" rounded @click="dialog_deletion = false">
              <span class="white-couleur">Non</span>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="success" rounded :loading="load" :disabled="load" @click="delDomain()">
              Oui
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import Permissions from '~/mixins/Permissions';

export default {
  name: 'settings-thematic-type',
  mixins: [Permissions],
  data: () => ({
    del_type_sae: null,
    del_index: null,
    search: '',
    loading: false,
    load: false,
    dialog_edit: false,
    dialog_deletion: false,
    headers: [
      { text: 'Type thématique', value: 'name' },
      { text: 'Type d\'évènement', value: 'event_type.name' },
      { text: 'Actions', value: 'action', sortable: false }
    ],
    thematicTypes_fields: {
      "Type thématique": "name",
    },
    snackbar: false,
    snackbar_message: '',
    snackbar_timeout: 5000,
    snackbar_color: '',

    editedIndex: -1,
    editedItem: {
      name: '',
      event_type_id: null,
    },
    defaultItem: {
      name: '',
      event_type_id: null,
    },

  }),

  created() {
    this.loading = true
    this.$store.dispatch("fetchEventTypes");
    this.fetchUtils();
    this.loading = false
  },

  computed: {
    event_types() { return this.$store.getters.event_types; },
    thematic_types() { return this.$store.getters.thematic_types; },
    formTitle() {
      return this.editedIndex === -1 ? 'Nouveau type thématique' : 'Editer le type thématique'
    },
  },

  watch: {
    dialog(val) {
      val || this.close()
    },
  },

  methods: {
    fetchUtils() {
      this.$store.dispatch("fetchThematicTypes");
    },

    editItem(item) {
      this.editedIndex = this.thematic_types.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog_edit = true
    },

    deleteItem(item) {
      this.del_index = this.thematic_types.indexOf(item);
      this.dialog_deletion = true;
      this.del_type_sae = item;
    },

    close() {
      this.dialog_edit = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    async save() {
      this.load = true;
      if (this.editedIndex > -1) {
        await this.$store.dispatch("updateThematicType", this.editedItem);
        this.snackbar = true;
        this.snackbar_color = 'success';
        this.snackbar_message = "Type thématique édité avec succès !";
      }
      else {
        await this.$store.dispatch("createThematicType", this.editedItem);
        this.snackbar = true;
        this.snackbar_color = 'success';
        this.snackbar_message = "Type thématique enregistré avec succès !";
      }
      this.close();
      this.load = false;
    },


    async delDomain() {
      this.load = true;
      await this.$store.dispatch("deleteThematicType", this.del_type_sae);
      this.dialog_deletion = false;
      this.snackbar = true;
      this.snackbar_color = 'success';
      this.snackbar_message = "Type thématique supprimé avec succès !";
      this.load = false;
    },

  }
};
</script>

<style scoped>
.couleur-orange {
  color: rgb(255, 152, 0);

  font-size: 1.2em;
}

.white-couleur {
  color: white;
}
</style>




// WEBPACK FOOTER //
// resources/assets/js/pages/settings/thematic-type.vue